export const emptyAgent = {
  id: "",
  name: "",
  email: "",
  phone: "",
  clients: [],
};

export const initialAgentState = {
  current: { ...emptyAgent },
  events: [],
  messages: [],
};

export function agentReducer(state = initialAgentState, action) {
  switch (action.type) {
    case "SET_AGENT":
      return { ...state, current: { ...emptyAgent, ...action.payload } };
    case "SET_EVENTS":
      return { ...state, events: action.payload || [] };
    case "ADD_EVENT":
      return { ...state, events: [...state.events, action.payload] };
    case "SET_MESSAGES":
      return { ...state, messages: action.payload || [] };
    case "ADD_MESSAGE":
      return { ...state, messages: [...state.messages, action.payload] };
    case "CLEAR_AGENT":
      return { ...initialAgentState };
    default:
      return state;
  }
}
